module.exports = __webpack_public_path__ + "static/media/logo.15b3f4f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1256
// module chunks = 0